import { z } from "zod";

export const spotIncentiveSchema = z.object({
  name: z.string().min(1, "Incentive name is required"),
  taskId: z.number().nullable().refine((val) => val !== null, {
    message: "Please select a task"
  }),
  resourceIds: z.array(z.number()).min(1, "Select at least one resource"),
  startDate: z.string(),
  endDate: z.string(),
  details: z.array(z.object({
    id: z.string(),
    image: z.instanceof(File).optional(),
    comment: z.string().optional(),
    timestamp: z.string(),
    document_id: z.number().optional()
  })).default([]),
  positiveTagIds: z.array(z.number()).default([]),
  negativeTagIds: z.array(z.number()).default([])
});

export type SpotIncentiveFormData = z.infer<typeof spotIncentiveSchema>;
